import { Badge, IconWrap, LockBoldIcon, Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

type Props = {
  isValidation: boolean
  shiftIsLocked: boolean
}
export const ModalRealHoursTitle: FC<Props> = ({
  isValidation,
  shiftIsLocked
}) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Modal.Header
      title={
        isValidation
          ? t('realHoursForm.validateShift')
          : t('realHoursForm.editRealHours')
      }
      desc={
        shiftIsLocked && (
          <Badge
            rightIcon={<IconWrap icon={<LockBoldIcon />} size='s' />}
            label={t('realHoursForm.planningLocked')}
            size='s'
          />
        )
      }
    />
  )
}
